// extracted by mini-css-extract-plugin
export var bg = "style-module--bg---qIf1";
export var forWhoSplash = "style-module--forWhoSplash--rHMwf";
export var image1 = "style-module--image1--aUflA";
export var image2 = "style-module--image2--u5QnG";
export var imageSplash = "style-module--imageSplash--l6xAH";
export var reverseRoot = "style-module--reverseRoot--cgY6D";
export var root = "style-module--root--dau9Z";